export default __webpack_public_path__ + "static/media/6.ed75c01f.png";